import wcs from '../libs/wcs'

import { actions } from './actions'
import { mutations } from './mutations'

// modules
import { footer } from './footer'
import { plp } from './plp/plp'
import { pdp } from './pdp'
import { labels } from './labels'
import { applePay } from './apple-pay'
import { frameGenius } from './frame-genius/frame-genius'
import { header } from './header/header'

import { virtualMirror } from './virtual-mirror/virtual-mirror'
import { doctorLocator } from './doctor-locator/doctor-locator'
import { genesys } from './genesys/genesys'
import { eyewearProtection } from './eyewear-protection/eyewear-protection'

const storeConfig = wcs.getStoreConfig()

export default (Vuex) => {
  const store = new Vuex.Store({
    modules: {
      plp,
      pdp,
      footer,
      labels,
      applePay,
      frameGenius,
      header,
      genesys,
      virtualMirror,
      doctorLocator,
      eyewearProtection,
    },
    state: {
      ui: {
        isHeaderPromo: false,
        isDesktop: false,
        isDashButtonSmall: false,
        newsletterOpenStatus: false,
      },
      openModalName: '',
      user: { name: '', logged: false, loaded: false, showMenu: false, menuItems: [] },
      sidebar: {
        loaded: false,
        show: false,
        wishlist: {
          loading: false,
          show: false,
          quantity: 0,
          items: [],
          details: {
            wishListHeader: '',
            wishlistId: 0,
          },
        },
        cart: {
          loading: false,
          show: false,
          quantity: 0,
          items: [],
          details: {
            subTotal: 0,
            shippingCost: 0,
            adjustment: 0,
            tax: 0,

            // TODO: refactor these two values to only use `totalToNumber`, because `total` is updated as a string
            total: 0,
            totalToNumber: 0,

            prescriptionItemPresentInOrder: false,
            orderId: 0,
          },
          promotionDetails: {
            PromoDesc: '',
            isFreeDelivery: false,
            FreeDeliveryPromoName: '',
            PromoAdjust: 0,
            PromoCode: '',
          },
          isPickupStore: false,
          showPaymentMessageBox: false,
        },
      },
      // TODO: remove this if not needed, or move this to header module
      navigationMenu: {
        currentTitle: '',
        menuId: null,
        menuIdClicked: null,
        showMenuId: false,
        linkClicked: null,
        showPanel: false,
        mouseOnSubMenu: false,
      },

      overlay: false,
      storeConfig,
      newsletter: {
        submitCounter: 1,
      },
      noEcommerceCounter: 0,
      lastWishlistItem: null,
      lastAddToBagItem: null,
      pickupStore: {
        show: true,
      },
      userSelfData: {},
      googleMapData: {
        google: {},
        map: {},
      },

      findInStore: {
        panelIsVisible: false,
        storeDetailsPanelIsVisible: false,
        googleMapsApiIsLoaded: false,
      },

      eyeMedIsVisible: false,
      afterpayIsVisible: false,
      isTrustPilotScriptLoaded: false,
      klarnaExpressScriptIsLoaded: false,
      klarnaIsInitialized: false,
      roxPanelOverlay: false,
      roxPanelOverlayType: '',
    },
    getters: {
      showSidebar: (state) => state.sidebar.show,
      showWishlist: (state) => state.sidebar.wishlist.show,
      showCart: (state) => state.sidebar.cart.show,
      wishlistQuantity: (state) => {
        return state.sidebar && state.sidebar.wishlist && state.sidebar.wishlist.quantity
      },
      cartQuantity: (state) => {
        return state.sidebar && state.sidebar.cart && state.sidebar.cart.quantity
      },
      navigationMenu: (state) => state.navigationMenu,
      isHeaderPromo: (state) => state.ui.isHeaderPromo || false,
      storeConfig: (state) => state.storeConfig,
      newsletterSubmitCounter: (state) => state.newsletter.submitCounter,
      orderId: (state) => state.sidebar.cart.details.orderId,
      cartItems: (state) => state.sidebar.cart.items,
      wishlistItems: (state) => state.sidebar.wishlist.items,
      userName: (state) => state.user.name,
      menuItems: (state) =>
        state.user.menuItems.filter((item) => !!item && Object.keys(item)?.length > 0),
      userLoggedIn: (state) => state.user.logged,
      lastWishlistItem: (state) => state.lastWishlistItem,
      lastAddToBagItem: (state) => state.lastAddToBagItem,
      showPickupStore: (state) => state.pickupStore.show,
      userSelfData: (state) => state.userSelfData,
      googleMapData: (state) => state.googleMapData,
      noEcommerceCounter: (state) => state.noEcommerceCounter,
      findInStorePanelIsVisible: (state) => state.findInStore.panelIsVisible,
      storeDetailsPanelIsVisible: (state) => state.findInStore.storeDetailsPanelIsVisible,
      googleMapsApiIsLoaded: (state) => state.findInStore.googleMapsApiIsLoaded,
      afterpayIsVisible: (state) => state.afterpayIsVisible,
      eyeMedIsVisible: (state) => state.eyeMedIsVisible,
      isDashButtonSmall: (state) => state.ui.isDashButtonSmall,
      newsletterOpenStatus: (state) => state.ui.newsletterOpenStatus,
      isTrustPilotScriptLoaded: (state) => state.isTrustPilotScriptLoaded,
      cartIsLoading: (state) => state.sidebar.cart.loading,
      showPaymentMessageBox: (state) => state.sidebar.cart.showPaymentMessageBox,
      klarnaExpressScriptIsLoaded: (state) => state.klarnaExpressScriptIsLoaded,
      klarnaIsInitialized: (state) => state.klarnaIsInitialized,
      getUi: (state) => state.ui,
      roxPanelOverlay: (state) => state.roxPanelOverlay,
      roxPanelOverlayType: (state) => state.roxPanelOverlayType,
    },
    mutations,
    actions,
  })

  return store
}
